import { CommonErrorState } from './definitions';

export class CommonErrorFactory 
{
	public static build(): CommonErrorState 
	{
		return {
			messages: [{ message: '401 Unauthorized' }],
			id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
			statusCode: 401,
			image: {
				iconPath: '/assets/401_Unauthorized.png',
				altText: '401 Unauthorized'
			}
		};
	}
}
